import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type ExternalCareEpisodeIdInputFields = {
  externalCareEpisodeId: string;
};

const ExternalCareEpisodeIdInput = ({
  externalCareEpisodeIdFieldConfig,
}: {
  externalCareEpisodeIdFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<ExternalCareEpisodeIdInputFields>();

  return (
    <InputField
      type="text"
      {...register("externalCareEpisodeId", {
        required: {
          value:
            externalCareEpisodeIdFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange externt vårdperiodnummer`,
        },
      })}
      label={t`Externt vårdperiodnummer`}
      showOptionalLabel={
        externalCareEpisodeIdFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.externalCareEpisodeId?.message}
    />
  );
};

export default ExternalCareEpisodeIdInput;
